"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
var _default2 = exports.default = {
  props: {
    /* 选择对话框类型 [input 可输入（默认）, onlySelect（只能通过对话框选择来改变）, onlyBtn (只有选择按钮，没有输入框), onlyDialog (只有对话框，打开方式需要额外的按钮进行控制)] */
    selectorType: {
      type: String,
      default: 'input'
    },
    /* 选择模式 [single（单选）（默认）, multiple（多选）] */
    chooseMode: {
      type: String,
      default: 'single'
    },
    /* 输入框绑定内容 */
    value: {
      type: [String, Number, Array],
      default: ''
    },
    // selectValue: String,
    /* 对话框的打开开关 */
    open: {
      type: Boolean,
      default: false
    },
    /* 输入框提示输入文字 */
    placeholder: {
      type: String,
      default: '请选择'
    },
    /* 对话框参数设置 */
    dialogOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 按钮图标 */
    iconsVisible: {
      type: Boolean,
      default: true
    }
  }
};